import { type ReactNode } from 'react';
import { Content, Sidebar, Footer, Header } from 'components/layout/index';

interface IAppLayoutProps {
  children: ReactNode;
}

export default function AppLayout({ children }: IAppLayoutProps) {
  return (
    <div className="app-layout">
      <Sidebar />
      <div className="wrapper">
        <Header />
        <div className="body">
          <Content content={children} />
        </div>
        <Footer />
      </div>
    </div>
  );
}
